import { InjectionToken } from '@angular/core';
import { Environment } from '../../../environments/environment.interface';

export const ENVIRONMENT = new InjectionToken<Environment>('environment');
export const WINDOW = new InjectionToken<Window>('window');
